export enum NotificationLinkedEntityType {
  Vehicle = 'vehicle'
}
